<template>
  <ServiceMerchant />

</template>

<script>
import ServiceMerchant from '@/views/public_0983cc/service/index.vue'

export default {
  components: {
    ServiceMerchant
  }
}
</script>

<style>

</style>
